import React from 'react'
import styles from './UIGameSpectators.module.scss'
import {Avatar} from '../../common/Avatar/Avatar'
import {Tooltip} from '@colonist/ui'
// eslint-disable-next-line no-restricted-imports
import {getLobbyImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage} from '@colonist/types'
import {useUIGameSpectatorsContext} from './UIGameSpectatorsContext'
import {PlayerColor} from '@colonist/game-states'

export interface UIGameSpectatorsProps {
    maxAvatarsVisible?: number
}

export const UIGameSpectators = ({maxAvatarsVisible = 3}: UIGameSpectatorsProps) => {
    const {spectators} = useUIGameSpectatorsContext()
    const visibleSpectators = spectators.slice(0, maxAvatarsVisible)
    const extraCount = spectators.length - maxAvatarsVisible

    if(spectators.length === 0) return null

    return (
        <div className={styles.spectatorsContainer}>
            <div className={styles.avatarsContainer}>
                {visibleSpectators.map((spectator, idx) => (
                    <Tooltip key={spectator.username + idx} title={spectator.username}>
                        <Avatar
                            color={PlayerColor.White}
                            className={styles.avatar}
                            image={spectator.avatar}
                            profilePictureUrl={spectator.profilePictureUrl} />
                    </Tooltip>
                ))}
                {extraCount > 0 && (
                    <div className={styles.extraCount}>+{extraCount}</div>
                )}
            </div>
            <div className={styles.eyeIcon}>
                <img src={getLobbyImagePath(LobbyImage.Eye)} />
            </div>
        </div>
    )
}
